import { copy } from "shared/assets";
import { DateChangeProps, IFieldType, IFormFields } from "shared/types";

const { userSocialSecurityForm, errors } = copy;

export const getFormFields = ({
  handleIssueDateChange,
  handleExpiryDateChange,
  isIssueBeforeExpiry,
  isExpiryInFuture,
}: {
  handleIssueDateChange: (date: DateChangeProps) => void;
  handleExpiryDateChange: (date: DateChangeProps) => void;
  isIssueBeforeExpiry: boolean;
  isExpiryInFuture: boolean;
}): IFormFields => {
  return [
    {
      name: "title",
      label: userSocialSecurityForm.fields.title,
      type: IFieldType.text,
    },
    {
      name: "documentType",
      label: userSocialSecurityForm.fields.documentType.title,
      note: userSocialSecurityForm.fields.documentType.note,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
    },
    {
      name: "issuingCountry",
      label: userSocialSecurityForm.fields.issuingCountry,
      type: IFieldType.country,
      validation: {
        required: errors.required,
      },
    },
    {
      name: "issuingAuthority",
      label: userSocialSecurityForm.fields.issuingAuthority,
      type: IFieldType.text,
    },
    {
      name: "formNumber",
      label: userSocialSecurityForm.fields.formNumber,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "issueDate",
      label: userSocialSecurityForm.fields.issueDate,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () =>
          isIssueBeforeExpiry ||
          userSocialSecurityForm.messages.issueBeforeExpiry,
      },
      onChange: (value: string) => handleIssueDateChange({ date: value }),
    },
    {
      name: "expiryDate",
      label: userSocialSecurityForm.fields.expiryDate,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () =>
          isExpiryInFuture || userSocialSecurityForm.messages.expiryInFuture,
      },
      onChange: (value: string) => handleExpiryDateChange({ date: value }),
    },
    {
      name: "files",
      label: userSocialSecurityForm.fields.file,
      type: IFieldType.files,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "info",
      label: userSocialSecurityForm.fields.info,
      type: IFieldType.rte,
      style: {
        gridColumn: "span 2",
      },
    },
  ];
};
